import { useAppSelector } from "../store";
import { selectSingleNews } from "./newsfeedSelector";

export const useSingleNews = (slug: string) => {
  return useAppSelector((state) => selectSingleNews(state, slug));
};
